import { Alert } from "../components/Alert/Alert.jsx";
import { PageHeading } from "../components/PageHeading/PageHeading.jsx";
import { ProfileManager } from "../components/ProfileManager/ProfileManager.jsx";
import { useApplicationDocument } from "../storage/useApplicationDocument.js";
import "./ProfilesPage.css";

export function ProfilesPage({ onSyncConnectionChange }) {
  const application = useApplicationDocument();

  if (application.error && !application.profile) {
    return <Alert tone="danger" heading="Unable to open Regulator">{application.error.message}</Alert>;
  }
  if (!application.profile) return <ProfilesLoading />;

  return <article className="profiles-page">
    <ProfileManager application={application} applicationError={application.error} onSyncConnectionChange={onSyncConnectionChange} />
  </article>;
}

function ProfilesLoading() {
  return <article className="profiles-page" aria-busy="true">
    <PageHeading description="Manage isolated portfolios, configurations, and prepared views.">Profiles</PageHeading>
    <div className="profile-loading" />
  </article>;
}
